// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:31.476Z
  unresolved dependencies: $productKindPicker
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:delivery_estimator': [],
  'minted:model/info_dialog': [],
  'minted:view/info_dialog': [],
  'minted:model/delivery_estimator/api': []
})(this, function (m_module, Backbone, $, _) {

var M = m_module.M;

M.View = M.View || {};
M.View.Order = M.View.Order || {};

/**
 * @class DeliveryEstimatorTool
 *
 * Renders a form that allows the customer to estimate their delivery date.
 * This View should eventually replace the DeliveryEstimatorDialog Qcodo view.
 */
M.View.Order.DeliveryEstimatorTool = Backbone.View.extend({

  events: {
    'change .expressService input': '_expressServiceChanged',
    'change .productKindPicker': '_productKindPickerChanged',
    'change .proofDaysPicker': '_proofDaysChanged',
    'change .shippingMethodPicker': '_shippingMethodChanged'
  },

  initialize: function() {
    this.template = this._getTemplate();

    this.productKindOptions = this.options.productKindOptions;

    var that = this;
    if (this.options.hasShippingMethodsPicker) {
      this.shippingMethods = [];
      this.getShippingOptions();
    }
  },

  _expressServiceChanged: function(e) {
    var expressServiceCheckbox = e.target;
    if (this.showExpressServiceCheckbox()) {
      if (expressServiceCheckbox.checked) {
        this.model.get('line_items')[0]['is_express_service'] = true;
      } else {
        this.model.get('line_items')[0]['is_express_service'] = false;
      }
      // Wipe all dates except for ordered_on in order to get a new delivery
      // estimate with express service.
      this.model.clearDatesAfter('ordered_on');
      this._clearProofData();
      this.getDeliveryEstimate();
    }
  },

  /**
   * Updates the product_kind in the estimatorPO when the
   * product kind picker changes.
   */
  _productKindPickerChanged: function(e) {
    // Set the picker's selected product kind.
    var that = this;
    var $productKindPicker = $(e.target);

    var lineItems = that.model.get('line_items');
    lineItems[0]['product_kind'] = $productKindPicker.val();
    that.model.set({'line_items': lineItems});

    that.toggleExpressServiceCheckbox();

    // Clear out dates and reset has_customer_facing_proof so that can be
    // queried again for the newly selected product kind
    that.model.clearDatesAfter('ordered_on');
    this._clearProofData();
    this.getShippingOptions();
  },

  _proofDaysChanged: function(e) {
    var $picker = $(e.target);
    var proofApprovalDays = parseInt($picker.val(), 10);
    var proofCreatedOn = this.model.getProofCreatedOn();
    var proofApprovedOn = new Date(proofCreatedOn);
    proofApprovedOn.setDate(proofCreatedOn.getDate() + proofApprovalDays);
    this.model.set({'proof_accepted_on': proofApprovedOn});
    this.model.clearDatesAfter('proof_accepted_on');
    this.getDeliveryEstimate();
  },

  _shippingMethodChanged: function(e) {
    var $picker = $(e.target);
    this.model.set({'shipping_method': $picker.val()});
    this.model.clearDatesAfter('ordered_on');
    this.getDeliveryEstimate();
  },

  _getTemplate: function() {
    if (this.options.template == 'checkout') {
      return M.Template.DeliveryEstimator.DeliveryEstimatorToolCheckout;
    } else {
      return M.Template.DeliveryEstimator.DeliveryEstimatorTool;
    }
  },

  _clearProofData: function() {
    this.model.unset('has_customer_facing_proof', {silent: true});
    this.model.unset('proof_acceptance_days', {silent: true});
    this.model.unset('proof_creation_days', {silent: true});
    this.model.unset('proof_creation_days_message', {silent: true});
  },

  showInternationalShippingMessage: function() {
    var selected_shipping_method = this.model.get('shipping_method');
    if (selected_shipping_method == 10 || selected_shipping_method == 11){
      this.$el.find(".internationalShippingMessage").show();
    } else {
      this.$el.find(".internationalShippingMessage").hide();
    }
  },

  render: function() {
    var that = this;
    this.$el = $(this.el);
    this.$el.empty();

    var templateVars = {
      productKindOptions: this.productKindOptions,
      proofDaysList: this._getProofingDaysList(),
      hasShippingMethodsPicker: this.options.hasShippingMethodsPicker,
      shippingMethods: this.shippingMethods,
      model: this.model,
      showExpressServiceCheckbox: this.showExpressServiceCheckbox()
    };
    var html = this.template(templateVars);
    this.$el.html(html);

    // Enable the datepicker widget.
    var datePicker = this.$el.find('.datePicker');
    datePicker.datepicker({
      dateFormat: 'yy/m/d',
      onClose: function() {
        var selectedDate = datePicker.datepicker('getDate');
        if (selectedDate) {
          that.model.set({'ordered_on': selectedDate});
          that.getDeliveryEstimate();
        }
      },
      nextText: '',
      prevText: ''
    });

    // Set the datepicker's date to the estimate's ordered_on date.
    datePicker.datepicker('setDate', this.model.getOrderedOn());

    // Set the product kind
    $productKindPicker = this.$el.find('.productKindPicker');
    $productKindPicker.val(this.model.get('line_items')[0]['product_kind']);

    // Update the shipping option
    if (this.model.get('shipping_method')) {
      var shippingMethodPicker = this.$el.find('.shippingMethodPicker');
      shippingMethodPicker.val(this.model.get('shipping_method'));
      this.showInternationalShippingMessage();
    }

    // Set the number of proofing days in the picker.
    var proofDaysPicker = this.$el.find('.proofDaysPicker');
    var proofCreatedOn = this.model.getProofCreatedOn();
    var proofAcceptedOn = this.model.getProofAcceptedOn();
    if (proofCreatedOn && proofAcceptedOn) {
      var dateDiff = proofAcceptedOn - proofCreatedOn;
      var oneDay = 24*60*60*1000;
      var proofApprovalDays = Math.round(dateDiff / oneDay);
      if (proofApprovalDays > 0) {
        proofDaysPicker.val(proofApprovalDays);
      }
    }

    // Proof description dialog
    var $proofDescriptionLink = $('.whatIsAProofLink');
    if ($proofDescriptionLink.length > 0) {
      var proofDescription = new M.Model.InfoDialog({
        title: 'what is a proof?',
        body: 'Your order will be typeset by one of our ' +
          'professional designers. We will email you the ' +
          'personalized digital proof for approval. Please ' +
          'approve your proof as quickly as possible. Every ' +
          'day your approval is delayed, including any change ' +
          'requests, the delivery of your order will be delayed ' +
          'by one day. Please note that we cannot print your ' +
          'order until we have your approval.'
      });
      var proofDescriptionDialog = new M.View.InfoDialog({
        model: proofDescription
      });
      $proofDescriptionLink.click(function() {
        proofDescriptionDialog.render();
      });
    }

    return this;
  },

  /**
   * Return a list of day options.
   *
   * This will be used to populate a select list so the customer can
   * choose the number of days it will take them to approve their proof.
   *
   * @return dict
   */
  _getProofingDaysList: function() {
    var daysList = {
      '1': '1 day by 8:30pm PST',
      '2': '2 days by 8:30pm PST',
      '3': '3 days by 8:30pm PST',
      '4': '4 days by 8:30pm PST',
      '5': '5 days by 8:30pm PST',
      '6': '6 days by 8:30pm PST',
      '7': '7 Days by 8:30pm PST'
    };

    return daysList;
  },

  showExpressServiceCheckbox: function() {
    var productKinds = [this.model.get('line_items')[0]['product_kind']];
    return (_.contains(productKinds, 'HYC'));
  },

  // Display the express service checkbox for certain product kinds.
  toggleExpressServiceCheckbox: function() {
    if (!this.showExpressServiceCheckbox()) {
      this.model.get('line_items')[0]['is_express_service'] = false;
    }
  },

  /**
   * Makes a request to the PHP shipping method service. Returns a list of
   * valid shipping options for the selected product kind.
   */
  getShippingOptions: function() {
    var that = this;
    var lineItem = this.model.get('line_items')[0];
    var url = '/shipping-method-service?product_kind=' +
      lineItem['product_kind'];
    return $.ajax({
      url: url,
      type: 'GET',
      dataType: 'json',
      success: function(response) {
        // Convert the list of objects into a dictionary to
        // make the data more friendly.
        that.shippingMethods = [];
        $.each(response, function(idx, option) {
          for (var id in option) {
            that.shippingMethods[id] = option[id];
          }
        });
        // Select the first option in the list
        if (!that.model.get('shipping_method')) {
          for (var id in that.shippingMethods) {
            that.model.set({'shipping_method': id});
            break;
          }
        }
        that.getDeliveryEstimate();
      }
    });
  },

  /**
   * Make a request to the delivery estimator service.
   */
  getDeliveryEstimate: function() {
    var that = this;

    that.model.set({'ignore_time_of_day': true});

    that.model.set();
    that.render();

    // TODO: Fix namespace, e.g. M.Api.DeliveryEstimator
    M.Model.DeliveryEstimator.Api.deliveryEstimate(
      this.model,
      function(response) {
        that.model.set(response[0]);
        that.render();
        that.trigger('get_delivery_estimate');
      }
    );
  }

});

return {
};

});
